import React from "react";

import DatePickerInput from "components/datePickerInput/DatePickerInput";
import TeesheetDatePickerNav from "elements/teesheet/TeesheetDatePickerNav";

interface IStatisticsBarMobileToolbarProps {
  selectedDate: Date;
  onDateChange: (date: Date) => void;
  search?: React.ReactNode;
  menu: React.ReactNode;
}

export default function StatisticsBarMobileToolbar(props: IStatisticsBarMobileToolbarProps) {
  const datePicker = (
    <DatePickerInput
      months={1}
      position="center"
      centeredInputText
      startingDate={props.selectedDate}
      setStartingDate={props.onDateChange}
      requireApply
    />
  );

  return (
    <div className="statistics-bar-mobile-toolbar">
      <div className="statistics-bar-mobile-toolbar-row">
        <div className="statistics-bar-mobile-toolbar-search">
          {props.search}
        </div>
        <div className="statistics-bar-mobile-toolbar-center">
          <TeesheetDatePickerNav selectedDate={props.selectedDate} onDateChange={props.onDateChange}>
            {datePicker}
          </TeesheetDatePickerNav>
        </div>
        <div className="statistics-bar-mobile-toolbar-menu">{props.menu}</div>
      </div>
    </div>
  );
}
